module.exports = __webpack_public_path__ + "static/media/popup.f019e128.png";